var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',_vm._g(_vm._b({on:{"change":_vm.onChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-btn-toggle',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }